import {Navigate} from "react-router-dom";
import { authService } from "../services/authService";

export default function ProtectedRoute({children,}) {

  const authenticated = authService.isAuthenticated();

  if (!authenticated) {
    return (
      <Navigate to="/admin/login" replace/>
    );
  }

  return children;
}